import { createTheme } from "@mui/material/styles";

    ////This is dark mode, we can change the variable from
    //GlobalTheme to DarkTheme/ Lighttheme later

export const GlobalTheme = {
    ButtonAppBar: {
        Main: '#1e2226', // Blackish
        Box: {
            flexGrow: 1
        }
    },
    BinCard: {
        Main: '#2e323a'
    },
    SiteCard: {
        Main: "#2d2d2d",
    }
    //Dashboard: {
    //    Main: 
    //    }
}



